import { useEffect } from 'react'

import { type IUserSlot } from '@/app/types/settingsTypes'
import { Loader, Modal } from '@/shared'

import style from './SlotsModal.module.scss'
import { UserSlots } from './UserSlots/UserSlots'

interface IProps {
    searchableAgentId: string | null
    userSlotsList: IUserSlot[] | null
    onSetSearchableAgentId: (searchableAgentId: string | null) => void
    onGetSlotsByAgentId: (agentId: string) => void
    onSetUserSlotsList: (userSlotsList: IUserSlot[] | null) => void
    onRefundRecord: (slotId: string, agentId: string, onSuccess?: () => void) => void
}

export const SlotsModal = (props: IProps) => {
    const {
        searchableAgentId,
        userSlotsList,
        onSetSearchableAgentId,
        onGetSlotsByAgentId,
        onSetUserSlotsList,
        onRefundRecord
    } = props

    useEffect(() => {
        if (searchableAgentId) {
            onGetSlotsByAgentId(searchableAgentId)
        }
    }, [searchableAgentId, onGetSlotsByAgentId])

    const onCloseHandler = () => {
        onSetSearchableAgentId(null)
        onSetUserSlotsList(null)
    }

    return (
        <Modal show={!!searchableAgentId} onClose={onCloseHandler}>
            <div className={style.container}>
                <div className={style.header}>
                    <span>Предстоящие встречи</span>
                </div>
                {searchableAgentId && userSlotsList && userSlotsList.length > 0 && (
                    <UserSlots
                        userSlotsList={userSlotsList}
                        searchableAgentId={searchableAgentId}
                        onRefundRecord={onRefundRecord}
                        onSetUserSlotsList={onSetUserSlotsList}
                    />
                )}
                {!userSlotsList && (
                    <div className={style.loaderWrapper}>
                        <Loader />
                    </div>
                )}
                {userSlotsList && userSlotsList.length === 0 && (
                    <div className={style.emptySlots}>
                        <span>Нет предстоящих встреч</span>
                    </div>
                )}
            </div>
        </Modal>
    )
}
